import React from "react";
import ReactECharts from "echarts-for-react";

const BarChart = ({ data, type }) => {
  // `data` should be an array of objects like:
  // [{ name: "A", value: 120, color: "#FF5733" }, { name: "B", value: 200, color: "#33C1FF" }]

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
    },
    xAxis: {
      type: "category",
      data: data.map((item) => item.name),
      axisLabel: { rotate: 90 },
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        type: type,
        data: data.map((item) => ({
          value: item.value,
          itemStyle: { color: item.color }, // custom color per bar
        })),
        barWidth: "50%",
      },
    ],
  };

  return (
    <ReactECharts option={option} style={{ height: "350px", width: "100%" }} />
  );
};

export default BarChart;
